<button *ngIf="form && checkComponent()" matTooltip="Chiudi Sopralluogo" type="button" [disabled]="disabled"
class="my-bounce btn closeRequestButton mx-2" (click)="openModal()">
{{ 'REQUEST.chiudiSopralluogo' | translate }}
</button>